<template>
        <client-only>
        <div class="p-40">
            <header id="sign-header" class="d-flex flex-wrap justify-content-center align-items-center pt-40 pb-80">
                <nuxt-link href="/" class="d-flex align-items-center ">
                <img src="~/assets/images/logos/top-auto-logo-black.svg" alt="" class="error-logo">
                </nuxt-link>        
            </header>
            <div class="d-flex justify-content-center align-items-center">
            <div class="text-center"> 
                <img v-if="error.statusCode == '404'" src="~/assets/images/error/404-TopAuto.svg" class="mb-40 error-illustration" alt="">   
                <h2 class="error-title">Désolé, cette page est introuvable.</h2>
                <p class="mx-auto mt-12 error-text">Le lien que vous suivi est peut-être rompu, la page a été supprimée. Il est également possible que l’URL soit incorrecte.</p>
                <button class="btn btn-solid-primary-600 mt-32 px-40" @click="handleClearRrror()">
                    Page d’accueil
                </button>
            </div>
            </div>
        </div>
    </client-only>
</template>

<script setup>
const {error} = defineProps(['error'])
const handleClearRrror = () => clearError({ redirect: '/'})
// console.log(error);
</script>

<style lang="scss" scoped>
    p{
        max-width: 280px;
    }

    .error-logo{
        width: 100px !important;
    }

    .error-title{
        font-size: 20px !important;
    }

    .error-text{
        font-size: 14px !important;
    }

    .error-illustration{
        max-width: 520px;
        width: 100%;
        height: auto;
    }

    @media (min-width: 786px){
        .error-logo{
            width: 200px !important;
        }

        .error-title{
            font-size: 28px !important;
        }

        .error-text{
            font-size: 16px !important;
        }
    }

    @media (max-width: 768px){
        .error-illustration{
            max-width: 320px;
        }
    }
</style>
